export default __webpack_public_path__ + "static/media/consent-2021.26cfa80a.jpg";